import React, { Component } from 'react';
import './index.css';

import Header from './header.js';
import Nav from './nav.js';
import Page from './page.js';
import Footer from './footer.js';
import Loading from './loading.js';

import Data from './data/global.json';

class App extends Component {
	constructor(props) {
		super(props);
		
		this.hashChanged = this.hashChanged.bind( this );
		this.fetchContent = this.fetchContent.bind( this );
		this.showLoading = this.showLoading.bind( this );
		this.setTitle = this.setTitle.bind( this );
		this.toggleNav = this.toggleNav.bind( this );
		
		this.state = {
			"animation_duration": 250,
			
			"base_url": "https://api.elezioni.io",
			"browse_url": "/browse",
			"filter_url": "/filter",
			"summary_url": "/summary",
			"stats_url": "/collection",	
			"popularity_url": "/popularity/log",			
			"nav_url": "/browse/nav",
			"topics_url": "/topics",
			"viz_url": "/stats",
			
			"loading": true,
			"location": null,
			"nav": false,
			"title":null,
			"isHome": false
		};
	}
	
	componentDidMount() {
		window.addEventListener('hashchange', this.hashChanged, false);
		this.hashChanged();
	}
	
	componentWillUnmount() {
		window.removeEventListener('hashchange', this.hashChanged, false);
  	}
  	
  	hashChanged() {
	  	this.showLoading( true );
	  	if ( !window.location.hash ) {
		  	window.location.hash = '/';
	  	}
	  	this.setState({
			  	"location": window.location.hash,
			  	"isHome": ( window.location.hash === '#/' ) ? true : false,
			  	"nav": false
			},
			() => {
				document.querySelector('[property="og:url"]').setAttribute( 'content', window.public_url + window.location.hash );
			}
		);
  	}
  	
  	toggleNav() {
	  	this.setState( { "nav": !this.state.nav } );
  	}
  	
  	showLoading( show ) {
	  	//console.log( 'switch: ', show );
	  	this.setState( { "loading": show } );
  	}
  	
  	setTitle(title) {
	  	this.setState(
	  		{ "title": title },
	  		() => {
		  		document.querySelector('title').innerText = (title) ? title + ' - ' + window.base_title : window.base_title;
	  		}
	  	);
  	}
  	
  	fetchContent( url, options, callback, error ) {
	  	if ( url ) {
			let headers = new Headers();
			options.headers = headers;
			fetch(url, options)
				.then( function( response ) {
					if ( response.ok && response.status === 200 ) {
						var contentType = response.headers.get("content-type");
						if ( contentType && ( contentType.indexOf("application/json") > -1 || contentType.indexOf("text/json") > -1  || contentType.indexOf("text/plain") > -1 ) ) {	
							return response.json().then(
								function(json) {
									if (typeof callback === 'function') {
										callback(json);
									}
								}
							).catch( function( error ) {
								if (typeof error === 'function') {
										error( error );
								}
							});
						} else {
							if (typeof error === 'function') {
								error( 'Wrong answer' );
							}
						}
					} else {
						if (typeof error === 'function') {
							error( error );
						}
					}
				})
				.catch( function( err ) {
					if (typeof error === 'function') {
						error( err );
					}
				});
		}
  	}
  
	render() {
		return (
			<div className="elezioni">
				<Header Title={this.state.title} ToggleNav={this.toggleNav} />
				<Nav BaseUrl={this.state.base_url} NavUrl={this.state.nav_url} Location={this.state.location} FetchContent={this.fetchContent} Show={this.state.nav} AnimationDuration={this.state.animation_duration} />
				<Page IsHome={this.state.isHome} BaseUrl={this.state.base_url} BrowseUrl={this.state.browse_url} FilterUrl={this.state.filter_url} StatsUrl={this.state.stats_url} PopularityUrl={this.state.popularity_url} VizUrl={this.state.viz_url} SummaryUrl={this.state.summary_url} TopicsUrl={this.state.topics_url} Location={this.state.location} FetchContent={this.fetchContent} ShowLoading={this.showLoading} AnimationDuration={this.state.animation_duration} SetTitle={this.setTitle} Data={Data} />
				<Footer />
				<Loading Show={this.state.loading}  AnimationDuration={this.state.animation_duration} />
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/Elezioni/index.js